/// <reference types="vite/client" />
import { setWorkerUrl } from 'maplibre-gl';
import mapLibreWorkerUrl from 'maplibre-gl/dist/maplibre-gl-worker.mjs?worker&url';

/**
 * Point MapLibre at the Vite-bundled worker so production never requests
 * a missing `/assets/maplibre-gl-worker.mjs` sibling of a hashed chunk.
 */
export function configureMapLibreWorker(): string {
  setWorkerUrl(mapLibreWorkerUrl);
  return mapLibreWorkerUrl;
}
